import * as types from './constants';

// Get My Creators Connected Scroll
export const getMyCreatorsConnectedScrollRequest = data => (
  { type: types.GET_MY_CREATORS_CONNECTED_SCROLL_REQUEST, payload: data }
);

export const getMyCreatorsConnectedScrollDone = data => (
  { type: types.GET_MY_CREATORS_CONNECTED_SCROLL_DONE, payload: data }
);

export const getMyCreatorsConnectedScrollFailed = errors => (
  { type: types.GET_MY_CREATORS_CONNECTED_SCROLL_FAILED, payload: errors }
);

export const getMyCreatorsConnectedScrollReset = () => (
  { type: types.GET_MY_CREATORS_CONNECTED_SCROLL_RESET }
);

// Optimistic operations
export const myCreatorsConnectedScrollOptimisticRemove = uuid => ({
  type: types.MY_CREATORS_CONNECTED_SCROLL_OPTIMISTIC_REMOVE,
  payload: uuid
});

export const myCreatorsConnectedScrollOptimisticAdd = userRow => ({
  type: types.MY_CREATORS_CONNECTED_SCROLL_OPTIMISTIC_ADD,
  payload: userRow
});

// Refresh
export const refreshMyCreatorsConnectedScrollRequest = data => (
  { type: types.REFRESH_MY_CREATORS_CONNECTED_SCROLL_REQUEST, payload: data }
);

export const refreshMyCreatorsConnectedScrollDone = data => (
  { type: types.REFRESH_MY_CREATORS_CONNECTED_SCROLL_DONE, payload: data }
);

export const refreshMyCreatorsConnectedScrollFailed = errors => (
  { type: types.REFRESH_MY_CREATORS_CONNECTED_SCROLL_FAILED, payload: errors }
);

// Operations
export const toggleMyCreatorsConnectedScroll = data => (
  { type: types.TOGGLE_MY_CREATORS_CONNECTED_SCROLL, payload: data }
);

export const toggleAllMyCreatorsConnectedScroll = data => (
  { type: types.TOGGLE_ALL_MY_CREATORS_CONNECTED_SCROLL, payload: data }
);

export const setFilter = data => (
  { type: types.SET_MY_CREATORS_CONNECTED_SCROLL_FILTER, payload: data }
);

export const setAllFilters = data => (
  { type: types.SET_MY_CREATORS_CONNECTED_SCROLL_ALL_FILTERS, payload: data }
);

export const clearFilters = (filterToUpdate, mobile) => (
  { type: types.CLEAR_MY_CREATORS_CONNECTED_SCROLL_FILTERS, payload: { filterToUpdate, mobile } }
);

export const myCreatorsConnectedScrollSetPage = data => (
  { type: types.MY_CREATORS_CONNECTED_SCROLL_SET_PAGE, payload: data }
);